import moment, { setDateFormat } from '../../../lib/moment';
import { DATE_FORMAT } from '../common/utilConstants';
import { PRODUCT_SORT_TYPE } from './productConstants';

/**
 *  페이지 이름
 */
export const EVENT_PAGE_NAME = {
  EVENT_CREATE: '기획전 등록',
  EVENT_EDIT: '기획전 편집',
  EVENT_IN_PROGRESS_LIST: '진행중인 기획전 리스트',
  EVENT_ALL_LIST: '전체 기획전 리스트',
};

/**
 *  기획전 상태
 */
export const EVENT_STATUS = {
  /**
   *   비활성
   */
  inactive: 0,
  /**
   *  활성
   */
  active: 1,
  /**
   *  무기한,
   */
  unlimited: 2,
} as const;

/**
 *  기획전 상태 텍스트
 */
export const EVENT_STATUS_TEXT = {
  [EVENT_STATUS.inactive]: '비활성',
  [EVENT_STATUS.active]: '활성',
  [EVENT_STATUS.unlimited]: '무기한',
} as const;

/**
 *  기획전 상태 SELECT 리스트
 */
export const EVENT_STATUS_SELECT_LIST = [
  {
    id: EVENT_STATUS.inactive,
    name: EVENT_STATUS_TEXT[EVENT_STATUS.inactive],
  },
  {
    id: EVENT_STATUS.active,
    name: EVENT_STATUS_TEXT[EVENT_STATUS.active],
  },
  {
    id: EVENT_STATUS.unlimited,
    name: EVENT_STATUS_TEXT[EVENT_STATUS.unlimited],
  },
];

export const EVENT_TAB_COLOR_STATUS_SELECT_LIST = [
  {
    id: true,
    name: '기본 색상',
  },
  {
    id: false,
    name: '색상 변경',
  },
];

export const EVENT_STATUS_V2 = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  UNLIMITED: 'unlimited',
} as const;

export const EVENT_STATUS_TEXT_V2 = {
  [EVENT_STATUS_V2.INACTIVE]: '비활성',
  [EVENT_STATUS_V2.ACTIVE]: '활성',
  [EVENT_STATUS_V2.UNLIMITED]: '무기한',
} as const;

/**
 *  기획전 상태 SELECT 리스트
 */
export const EVENT_STATUS_SELECT_LIST_V2 = [
  {
    id: EVENT_STATUS_V2.INACTIVE,
    name: EVENT_STATUS_TEXT_V2[EVENT_STATUS_V2.INACTIVE],
  },
  {
    id: EVENT_STATUS_V2.ACTIVE,
    name: EVENT_STATUS_TEXT_V2[EVENT_STATUS_V2.ACTIVE],
  },
  {
    id: EVENT_STATUS_V2.UNLIMITED,
    name: EVENT_STATUS_TEXT_V2[EVENT_STATUS_V2.UNLIMITED],
  },
];

/**
 *  기획전 아이템 리스트 테이블 타입
 */
export const EVENT_ITEM_LIST_TABLE_TYPE = {
  /**
   *  선택된 기획전 아이템 리스트
   */
  SELECTED_EVENT_SECTION_ITEM: 0,
  /**
   *  기획전 아이템 리스트
   */
  EVENT_SECTION_ITEM: 1,
};

/**
 *  기획전 제목 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_EVENT_MAIN_TITLE_TEXT = 30;

/**
 *  기획전 본문 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_EVENT_CONTENT_TEXT = 40;

/**
 *  기획전 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_EVENT_MEMO_TEXT = 3000;

/**
 *  기획전 기간 PLACEHOLDER 텍스트
 */
export const PLACEHOLDER_TEXT_EVENT_PERIOD_DATE = 'YYYY년 M월 D일 H시 m분 s초';

/**
 *  검색 시 노출되는 이미지 최대 개수
 */
export const MAXIMUM_NUMBER_OF_EVENT_SEARCH_IMG = 1;

/**
 *  기획전 편집 페이지 form name
 */
export const EVENT_EDIT_PAGE_FORM_NAME = {
  /**
   *  검색 시 노출되는 이미지
   */
  SEARCH_IMG: 'searchImg',
  /**
   *  기획전 섹션
   */
  EVENT_SECTION: 'eventSection',
};

/**
 *  기획전 리스트가 없을 때 보여주는 텍스트
 */
export const EVENT_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 기획전 리스트가 없습니다.';

/**
 *  기획전 리스트 검색 키워드 타입
 */
export const EVENT_LIST_SEARCH_KEYWORD_TYPE = {
  /**
   *  제목
   */
  MAIN_TITLE: 0,
};

/**
 *  기획전 리스트 검색 키워드 타입 텍스트
 */
export const EVENT_LIST_SEARCH_KEYWORD_TYPE_TEXT = {
  [EVENT_LIST_SEARCH_KEYWORD_TYPE.MAIN_TITLE]: '제목',
};

/**
 *  기획전 정보 탭 index
 */
export const EVENT_SAVE_INFO_TAB_INDEX = 0;
export const EVENT_SECTION_TAB_INDEX = 0;

/**
 *  기획전 섹션 타입
 */
export const EVENT_SECTION_TYPE = {
  /**
   *   이미지
   */
  image: 0,
  /**
   *  영상
   */
  video: 1,
  /**
   *  애니메이션
   */
  animation: 2,
  /**
   *  스와이프
   */
  swipe: 3,
};

/**
 *  기획전 섹션 타입 텍스트
 */
export const EVENT_SECTION_TYPE_TEXT = {
  /**
   *   이미지
   */
  [EVENT_SECTION_TYPE.image]: '이미지',
  /**
   *  영상
   */
  [EVENT_SECTION_TYPE.video]: '영상',
  /**
   *  애니메이션
   */
  [EVENT_SECTION_TYPE.animation]: '애니메이션',
  /**
   *  스와이프
   */
  [EVENT_SECTION_TYPE.swipe]: '스와이프',
};

/**
 *  기획전 섹션 타입 SELECT LIST
 */
export const EVENT_SECTION_TYPE_SELECT_LIST = [
  {
    id: 'image',
    name: EVENT_SECTION_TYPE_TEXT[EVENT_SECTION_TYPE.image],
  },
  {
    id: 'video',
    name: EVENT_SECTION_TYPE_TEXT[EVENT_SECTION_TYPE.video],
  },
  {
    id: 'animation',
    name: EVENT_SECTION_TYPE_TEXT[EVENT_SECTION_TYPE.animation],
  },
  {
    id: 'swipe',
    name: EVENT_SECTION_TYPE_TEXT[EVENT_SECTION_TYPE.swipe],
  },
];

export const EVENT_SECTION_TYPE_V2 = {
  IMAGE: 'image',
  VIDEO: 'video',
  ANIMATION: 'animation',
  SWIPE: 'swipe',
  TEXT: 'text',
} as const;

/**
 *  기획전 섹션 타입 텍스트
 */
export const EVENT_SECTION_TYPE_TEXT_V2 = {
  [EVENT_SECTION_TYPE_V2.IMAGE]: '이미지',
  [EVENT_SECTION_TYPE_V2.VIDEO]: '영상',
  [EVENT_SECTION_TYPE_V2.ANIMATION]: '애니메이션',
  [EVENT_SECTION_TYPE_V2.SWIPE]: '스와이프',
  [EVENT_SECTION_TYPE_V2.TEXT]: '텍스트',
};

/**
 *  기획전 섹션 타입 SELECT LIST
 */
export const EVENT_SECTION_TYPE_SELECT_LIST_V2 = [
  {
    id: EVENT_SECTION_TYPE_V2.IMAGE,
    name: EVENT_SECTION_TYPE_TEXT_V2[EVENT_SECTION_TYPE_V2.IMAGE],
  },
  {
    id: EVENT_SECTION_TYPE_V2.VIDEO,
    name: EVENT_SECTION_TYPE_TEXT_V2[EVENT_SECTION_TYPE_V2.VIDEO],
  },
  {
    id: EVENT_SECTION_TYPE_V2.ANIMATION,
    name: EVENT_SECTION_TYPE_TEXT_V2[EVENT_SECTION_TYPE_V2.ANIMATION],
  },
  {
    id: EVENT_SECTION_TYPE_V2.SWIPE,
    name: EVENT_SECTION_TYPE_TEXT_V2[EVENT_SECTION_TYPE_V2.SWIPE],
  },
  {
    id: EVENT_SECTION_TYPE_V2.TEXT,
    name: EVENT_SECTION_TYPE_TEXT_V2[EVENT_SECTION_TYPE_V2.TEXT],
  },
];

/**
 *  기획전 애니메이션 섹션 타입 기본 시간 (ms)
 */
export const DEFAULT_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME = 500;

/**
 *  기획전 애니메이션 섹션 타입 최대 시간 (ms)
 */
export const MAXIMUM_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME = 3000;

/**
 *  기획전 애니메이션 섹션 타입 최소 시간 (ms)
 */
export const MINIMUM_EVENT_ANIMATION_SECTION_TYPE_INTERVAL_TIME = 100;

/**
 *  기획전 애니메이션 섹션 타입 이미지 최소 개수
 */
export const MAXIMUM_NUMBER_OF_EVENT_ANIMATION_SECTION_TYPE_IMG = 30;

/**
 *  기획전 애니메이션 섹션 타입 이미지 최대 개수
 */
export const MINIMUM_NUMBER_OF_EVENT_ANIMATION_SECTION_TYPE_IMG = 1;

/**
 *  기획전 이미지 섹션 타입 이미지 최소 개수
 */
export const MAXIMUM_NUMBER_OF_EVENT_IMAGE_SECTION_TYPE_IMG = 1;

/**
 *  기획전 이미지 섹션 타입 이미지 최대 개수
 */
export const MINIMUM_NUMBER_OF_EVENT_IMAGE_SECTION_TYPE_IMG = 1;

/**
 *  기획전 비디오 섹션 타입 이미지 최소 개수
 */
export const MAXIMUM_NUMBER_OF_EVENT_VIDEO_SECTION_TYPE_IMG = 1;

/**
 *  기획전 비디오 섹션 타입 이미지 최대 개수
 */
export const MINIMUM_NUMBER_OF_EVENT_VIDEO_SECTION_TYPE_IMG = 1;

/**
 *  기획전 스와이프 섹션 타입 이미지 최소 개수
 */
export const MAXIMUM_NUMBER_OF_EVENT_SWIPE_SECTION_TYPE_IMG = 7;

/**
 *  기획전 스와이프 섹션 타입 이미지 최대 개수
 */
export const MINIMUM_NUMBER_OF_EVENT_SWIPE_SECTION_TYPE_IMG = 1;

/**
 *  기획전 텍스트 섹션 최대 글자수
 */
export const MAXIMUM_NUMBER_OF_EVENT_TEXT_SECTION_TYPE_TEXT = 30;

/**
 *  섹션 이동 탭 최대 글자수
 */
export const MAXIMUM_NUMBER_OF_EVENT_SECTION_MOVE_TAB_TEXT = 15;

/**
 *  섹션 이동 탭 최대 글자수
 */
export const MAXIMUM_NUMBER_OF_EVENT_SECTION_COLOR_SET_TEXT = 7;

/**
 *  기획전 아이템의 개수
 */
export const NUMBER_OF_EVENT_ITEM_COUNT = 1000;

/**
 *  기획전 섹션 아이템의 개수
 */
export const NUMBER_OF_EVENT_SECTION_ITEM_COUNT = 40;

/**
 *  기획전 섹션 최대 개수
 */
export const MAXIMUM_NUMBER_OF_EVENT_SECTION = 30;

/**
 *  기획전 섹션 최소 개수
 */
export const MINIMUM_NUMBER_OF_EVENT_SECTION = 1;

/**
 *  기획전 클릭 링크 URL 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_EVENT_CLICK_LINK_URL_TEXT = 1000;

/**
 *  기획전 링크 영역 최대 개수
 */
export const MAXIMUM_NUMBER_OF_EVENT_IMAGE_SECTION_AREA_LINK = 30;

/**
 * 기획전 저장 초기 값
 */
export const EVENT_SAVE_INITIAL_VALUE = {
  mainTitle: null,
  status: EVENT_STATUS_V2.INACTIVE,
  period: {
    startDate: setDateFormat(moment(), DATE_FORMAT.YMD_HM_DASH_FORMAT),
    endDate: setDateFormat(moment().add(7, 'day'), DATE_FORMAT.YMD_HM_DASH_FORMAT),
  },
  contents: null,
  memo: null,
  itemDefaultSortType: PRODUCT_SORT_TYPE.RECOMMENDATION,
  isItemFilterExpose: false,
  eventAttachmentList: [],
  eventSectionList: [],
  eventProductList: [],
  eventTagList: [],
};

/**
 * 기획전 저장 요청 결과
 * @type {{SUCCESS: string, NONE: string, FAIL: string}}
 */
export const EVENT_SAVE_RESULT = {
  // 미요청
  NONE: 'NONE',
  // 성공
  SUCCESS: 'SUCCESS',
  // 실패
  FAIL: 'FAIL',
} as const;
